import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { AutoAwesomeOutlined, WidgetsOutlined, ArrowForwardRounded } from "@mui/icons-material";
import logo from "assets/images/logoBlanco.png";
import { focusSx } from "./welcomeStyles";
export default function WelcomeHero({ role }) {
  return (
    <Box
      component="section"
      aria-label="Bienvenida"
      sx={{
        position: "relative",
        isolation: "isolate",
        overflow: "hidden",
        borderRadius: 4,
        background: "linear-gradient(115deg, #112d38 0%, #174b4d 100%)",
        p: { xs: 3, md: 4.5 },
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.5fr 1fr" },
        gap: 4,
        "&:before": {
          content: '""',
          position: "absolute",
          width: 460,
          height: 460,
          border: "1px solid rgba(154,232,209,.12)",
          borderRadius: "50%",
          right: -120,
          top: -220,
          zIndex: -1,
        },
        "&:after": {
          content: '""',
          position: "absolute",
          width: 320,
          height: 320,
          border: "65px solid rgba(154,232,209,.035)",
          borderRadius: "50%",
          right: -55,
          bottom: -210,
          zIndex: -1,
        },
      }}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
          <AutoAwesomeOutlined sx={{ color: "var(--welcome-accent)", fontSize: 19 }} />
          <Typography sx={{ color: "#c4e3dc", fontSize: 11, letterSpacing: 2, fontWeight: 700 }}>
            HECHO PARA TU DÍA A DÍA
          </Typography>
        </Box>
        <Typography
          component="h2"
          sx={{
            color: "#fff",
            fontSize: { xs: 31, sm: 39, lg: 46 },
            fontWeight: 700,
            letterSpacing: -1.5,
            lineHeight: 1.15,
            maxWidth: 530,
          }}
        >
          Tu operación,
          <br />
          en un solo{" "}
          <Box component="span" sx={{ color: "var(--welcome-accent)" }}>
            lugar.
          </Box>
        </Typography>
        <Typography sx={{ color: "#c4d9dc", fontSize: 14, lineHeight: 1.8, mt: 2, maxWidth: 460 }}>
          Encuentra tus herramientas, consulta la información que necesitas y continúa con tu
          jornada.
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 3, flexWrap: "wrap" }}>
          <Button
            component="a"
            href="#mis-modulos"
            endIcon={<ArrowForwardRounded />}
            sx={{
              "&&": {
                bgcolor: "var(--welcome-accent)",
                color: "var(--welcome-ink)",
                minHeight: 44,
                px: 2.5,
                textTransform: "none",
                fontSize: 13,
                fontWeight: 700,
                borderRadius: 2,
              },
              "&&:hover": { bgcolor: "var(--welcome-accent)", filter: "brightness(.9)" },
              ...focusSx,
            }}
          >
            Ver mis módulos
          </Button>
          {role && (
            <Typography sx={{ color: "#c4d9dc", fontSize: 12 }}>
              Tu rol:{" "}
              <Box component="strong" sx={{ color: "#fff", fontWeight: 600 }}>
                {role}
              </Box>
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: 3,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Gopass"
          sx={{ width: 132, height: 45, objectFit: "contain" }}
        />
        <Box
          sx={{
            width: "100%",
            maxWidth: 280,
            border: "1px solid rgba(211,244,235,.2)",
            borderRadius: 3,
            p: 2.5,
            bgcolor: "rgba(255,255,255,.04)",
            backdropFilter: "blur(4px)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <WidgetsOutlined sx={{ color: "#a6e3c9", fontSize: 24 }} />
            <Box
              component="span"
              sx={{ width: 25, height: 3, bgcolor: "var(--welcome-accent)", borderRadius: 5 }}
            />
          </Box>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>
            Un inicio a tu medida
          </Typography>
          <Typography sx={{ color: "#c4d9dc", fontSize: 12, lineHeight: 1.8, mt: 0.75 }}>
            Aquí están los módulos habilitados para tu cuenta y las guías para usarlos.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
WelcomeHero.propTypes = { role: PropTypes.string };
